import {TextInput} from "@client/forms";
import * as utils from "@client/utils";
import {Schema} from "@reactivated";
import * as React from "react";

const styles = {
    navigation:
        "px-2.5 bg-[#FAFAFA] max-w-[900px] w-full mx-auto flex flex-col gap-2.5",
    input: "share-input text-[10.5px] m-0",
} as const;

interface Props {
    share: {
        type: Schema["rpc_share_detail_output"]["type"];
        share_uuid: string;
    };
}

export class ShareBar extends React.Component<Props> {
    inputCtrl = React.createRef<HTMLInputElement>();

    componentDidMount() {
        this.inputCtrl.current!.focus();
        this.inputCtrl.current!.select();
    }

    getMessage() {
        const {type} = this.props.share;

        switch (type) {
            case "profile":
                return "Give out this URL and people will be able to view your profile and macros.";
            case "day":
                return "Give out this URL and people will be able to view this day.";
            case "recipe":
                return "Give out this URL and people will be able to view and use this recipe.";
            case "meal":
                return "Give out this URL and people will be able to view and copy this meal.";
            case "entry":
                return "Give out this URL and people will be able to view this entry.";
            default: {
                const _exhaustiveCheck: never = type;
                return _exhaustiveCheck;
            }
        }
    }

    render() {
        const {props} = this;
        const url = `${utils.getBaseURLWithOriginForCapacitor()}/share/${
            props.share.share_uuid
        }/`;
        const message = this.getMessage();

        return (
            <div className={styles.navigation}>
                <p>{message}</p>
                <TextInput
                    small
                    name=""
                    ref={this.inputCtrl}
                    readOnly
                    onChange={() => {}}
                    value={url}
                />
            </div>
        );
    }
}
